/**
 * @name ResetPasswordPage
 * @description Página de recuperação de senha
 * @author Gabriel M. Guimarães | gabrielmg7
 */

import ResetPasswordComponent from '@/components/pages/Auth/ResetPassword/ResetPassword';

export const ResetPasswordPage = ResetPasswordComponent;
